import { Injectable, Inject } from 'ng-metadata/core';
import { IAppContainerPlaceholderNavItem, IAppContainerState, AppContainerStateChangeName, IAppContainerCompanyState } from './shared/shared.interfaces';
import * as lzjs from 'lzjs';

const LEGACY_NAV_IS_MINIMIZED_COOKIE = 'mwNavIsMinimized';

@Injectable()
export class AppContainerStateService {
    private appContainerState: IAppContainerState;
    private mwAppContainerStateCookieName: string = 'mwAppContainerState';

    constructor(@Inject('$cookies') private $cookies: ng.cookies.ICookiesService,
                @Inject('MW_STATE_TRACKING_ENABLED') private MW_STATE_TRACKING_ENABLED: boolean) {
        'ngInject';
        this.setInitialState();
    }

    setInitialState(): void {
        let existingCookieString: string = this.$cookies.get('mwAppContainerState');
        let existingCookieObject: IAppContainerState;

        if (existingCookieString) {
            try {
                existingCookieObject = JSON.parse(lzjs.decompressFromBase64(existingCookieString));
            } catch (err) {
                // Malformed JSON
            }
        }

        if (existingCookieObject) {
            this.appContainerState = existingCookieObject;
        } else {
            this.appContainerState = {
                initials: '',
                company: null,
                navigation: [],
                pageName: '',
                helpText: '',
                isNavigationMinimized: true,
                footerLinks: []
            };
        }
    }

    getIsNavigationMinimized(): boolean {
        return this.MW_STATE_TRACKING_ENABLED ? this.appContainerState.isNavigationMinimized : (this.$cookies.get(LEGACY_NAV_IS_MINIMIZED_COOKIE) === 'false' ? false : true);
    }

    updateAppContainerState(propertyName: AppContainerStateChangeName, payload: string | Array<IAppContainerPlaceholderNavItem> | IAppContainerCompanyState | boolean | Array<string>) {
        this.appContainerState[propertyName] = payload;

        if (propertyName == AppContainerStateChangeName.isNavigationMinimized) {
            this.$cookies.put(LEGACY_NAV_IS_MINIMIZED_COOKIE, payload.toString());
        }

        if (this.MW_STATE_TRACKING_ENABLED) {
            this.setStateCookie();
        }
    }

    removeStateCookie(): void {
        if (this.MW_STATE_TRACKING_ENABLED) {
            let host = window.location.hostname;

            this.$cookies.remove(this.mwAppContainerStateCookieName, {
                domain: host,
                path: '/'
            });
        }
    }

    setStateCookie(): void {
        let stateCookie: string;

        try {
            stateCookie = lzjs.compressToBase64(JSON.stringify(this.appContainerState));
        } catch (err) {
            // Something went wrong with the stringify
        }

        if (stateCookie) {
            let host = window.location.hostname;

            this.$cookies.put(this.mwAppContainerStateCookieName, stateCookie, {
                domain: host,
                path: '/'
            });
        }
    }

}



// WEBPACK FOOTER //
// ./src/lib/components/app-container/app-container-state.service.ts